import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginRight: theme.spacing(4),
  },
}));

export default useStyles;
